import { type ReactNode } from "react";

import { Text } from "../Text";

export interface InformationSectionTextContentProps {
  children: ReactNode;
}

export function InformationSectionTextContent({ children }: InformationSectionTextContentProps) {
  return (
    <Text variant="body1" sx={{ color: (theme) => theme.palette.text.secondary, lineHeight: 1.25 }}>
      {children}
    </Text>
  );
}
